const dateFormat = (date: string | undefined) => {
    const dateString = date === undefined ? '' : `${date}`;
    if (dateString.length === 8) {
        const yyyy = dateString.substr(0, 4);
        const MM = dateString.substr(4, 2);
        const dd = dateString.substr(6, 2);
        return (
            <>{yyyy}-{MM}-{dd}</>
        );
    }
    const dateObj = new Date(dateString);
    if (Number.isNaN(dateObj.getFullYear())) {
        return (<>{dateString}</>);
    }
    const yyyy = dateObj.getFullYear();
    const MM = ('0' + (dateObj.getMonth() + 1)).slice(-2);
    const dd = ('0' + dateObj.getDate()).slice(-2);
    return (
        <>{yyyy}-{MM}-{dd}</>
    );
}

export default dateFormat;